import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class HeaderScroll {
	constructor() {
		gsap.registerPlugin(ScrollTrigger)
		this.header = document.querySelector('header')
		if (!this.header) return

		this.trigger = document.querySelector('[data-banner]')

		this.#init()
	}

	#init() {
		if (this.trigger) {
			ScrollTrigger.create({
				trigger: this.trigger,
				start: 'bottom top+=100px',
				onEnter: () => this.header.classList.add('header-scrolling'),
				onLeaveBack: () => this.header.classList.remove('header-scrolling'),
			})
		}

		let lastY = 0
		ScrollTrigger.create({
			start: 0,
			end: 'max',
			onUpdate: (self) => {
				const currentY = self.scroll()
				if (currentY > lastY && currentY > 100) {
					this.header.classList.add('header-hidden')
				} else {
					this.header.classList.remove('header-hidden')
				}
				lastY = currentY
			},
		})
	}
}
